import React from 'react'
import PropTypes from 'prop-types'
import { ArrowForwardIcon } from '../../mui/Icons/index'
import { Button, Typography, Box } from '../../mui/Core/index'
import { useTheme } from '../../mui/Styles/index'

function TwoLineButton({ lineOne, lineTwo, handleButtonAction }) {
  const theme = useTheme()

  const twoLinedButtonStyle = {
    boxShadow: `1px 1px ${theme.palette.shadow.dark}`,
    minHeight: '89px',
    minWidth: '496px',
    borderRadius: '12px',
    padding: '15px 10px 15px 24px',
    backgroundColor: theme.palette.common.white,
    border: 'none',
    textAlign: 'left',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.white[50],
      border: 'none',
    },
  }

  const buttonTextWrapper = { display: 'flex', flexDirection: 'column', width: '100%' }

  const buttonTitleStyle = {
    fontSize: '20px',
    fontFamily: 'SanomatMedium',
    color: `${theme.palette.primary.main} !important`,
    letterSpacing: 'normal',
    display: 'block',
  }

  const buttonBodyStyle = {
    fontSize: '14px',
    fontFamily: 'AtlasGroteskRegular',
    marginTop: '7px',
    letterSpacing: 'normal',
    display: 'block',
  }

  const arrowStyle = {
    color: theme.palette.common.black,
    fontSize: '24px !important',
    marginRight: '18px',
  }

  return (
    <Button
      sx={twoLinedButtonStyle}
      variant='outlined'
      endIcon={<ArrowForwardIcon sx={arrowStyle} />}
      onClick={handleButtonAction}
    >
      <Box sx={buttonTextWrapper}>
        {lineOne && <Typography sx={buttonTitleStyle}>{lineOne}</Typography>}
        {lineTwo && <Typography sx={buttonBodyStyle}>{lineTwo}</Typography>}
      </Box>
    </Button>
  )
}

TwoLineButton.propTypes = {
  lineOne: PropTypes.string.isRequired,
  lineTwo: PropTypes.string,
  handleButtonAction: PropTypes.func.isRequired,
}
export default TwoLineButton
